module.exports = __webpack_public_path__ + "static/media/search-icon.5bd74fb0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/AppHeader/assets/search-icon.svg
// module id = ./src/common/AppHeader/assets/search-icon.svg
// module chunks = 14